import React from 'react';
import Typography from '@material-ui/core/Typography';
import styled from "@emotion/styled";

const DivContainer = styled.div`
        height: 100px;
        background-color: #d4e9e2;
        padding: 10px;
        margin-top: 3px;
        margin-bottom: 0;
    `;
const DivContainerInterno = styled.div`
        vertical-align: top;
        display: inline-block;
        height: 100%;
    `;
const DivExterior = styled.div`
        display: table;
        height: 100%;
    `;
const DivInterior = styled.div`
        display: table-cell;
        height: 100%;
        text-align: center;
        vertical-align: middle;
    `;
const ContentStyle = styled(Typography)`
        font-size: 24px;
        height: 28px;
        font-weight: 400;
        color: #9b9b9b;
        font-family: Work Sans;
        margin-left: 20px;
    `;

const Jumbotron = (props) => {
    const { iconePath, alt, content } = props;
    return (
        <div>
            <DivContainer>
                <DivContainerInterno>
                    <DivExterior>
                        <DivInterior>
                            <img
                                style={{ marginLeft: 45, width: 65 }}
                                src={iconePath}
                                alt={alt}
                            />
                        </DivInterior>
                    </DivExterior>
                </DivContainerInterno>
                <DivContainerInterno>
                    <DivExterior>
                        <DivInterior>
                            <ContentStyle variant="h6" color="inherit">
                                { content }
                            </ContentStyle>
                        </DivInterior>
                    </DivExterior>
                </DivContainerInterno>
            </DivContainer>
        </div>
    )
}

export default Jumbotron;